import * as React from 'react';
export const tinabaSvg = React.forwardRef(function tinabaSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4 16.484v8.101c0 1.872 1.584 3.389 3.54 3.389 1.955 0 3.54-1.517 3.54-3.389v-4.724c0-.365.31-.66.69-.66.38 0 .69.295.69.66v4.724c0 1.872 1.584 3.389 3.54 3.389 1.955 0 3.54-1.517 3.54-3.389v-7.438c0-.364.31-.66.69-.66.381 0 .69.296.69.66v7.438c0 1.872 1.585 3.389 3.54 3.389 1.956 0 3.54-1.517 3.54-3.389v-8.1C27.999 10.14 22.626 5 16 5S4 10.141 4 16.484Z',
      fill: '#FF5E00',
    }),
  );
});
tinabaSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var tinaba = {
  category: 'brand',
  colorable: false,
  name: 'tinaba',
  svg: tinabaSvg,
};
